import { useLocation } from 'react-router-dom';
import qs from 'qs';

export default function useQueryParams() {
  const location = useLocation();
  return qs.parse(location.search.substr(1));
}
